

export const CustomEquipmentTypes = [
    { value: 'cmm', label: 'CMM' },
    { value: 'vmm', label: 'VMM' },
    { value: 'other', label: 'Other' }
] as const;
export type CustomEquipmentType = typeof CustomEquipmentTypes[number]['value'];

export interface CustomEquipmentBase<ObjectIdType = string> {
    _id?: ObjectIdType;
    name: string;
    displayName: string;
    sharepointFolder?: string;
    type: CustomEquipmentType;
    cmmConfigId?: ObjectIdType;
    badgeText?: string;
    badgeColor?: string;
    isActive: boolean;
}
